import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import {
    BSKT_Lop,
    BSKT_Lop_ViewModel,
    CreateLopHocBSKTRequest,
    ThongKeVaMoLopTuDongResponse
} from '../../services/lop/LopModels';

interface LopState {
    listData: BSKT_Lop_ViewModel[];
    status: 'idle' | 'loading' | 'succeeded' | 'failed' | 'need_loading';
    selectedId: number | null;
    selectedDotHocId: number | null;
    isShowCreateOrEditModal: boolean;
    isShowConfirmDeleteModal: boolean;
    createOrEditModel: CreateLopHocBSKTRequest | null;
    thongKeVaMoLopData: ThongKeVaMoLopTuDongResponse | null;
    listLopHocCombobox: BSKT_Lop[];
}

const initialState: LopState = {
    listData: [],
    listLopHocCombobox: [],
    status: 'idle',
    selectedId: null,
    isShowCreateOrEditModal: false,
    isShowConfirmDeleteModal: false,
    createOrEditModel: {
        Chuyen_nganhs: '',
        ID_chuyen_nganhs: '',
        Den_ngay: new Date(),
        ID_cb: '',
        ID_dot_hoc: 0,
        ID_lop_bskt: 0,
        ID_mon: 0,
        ID_phong: 0,
        Ky_hieu_lop: '',
        STT_lop: '',
        Ten_lop_bskt: '',
        Tu_ngay: new Date()
    },
    thongKeVaMoLopData: null,
    selectedDotHocId: null
};

const lopTinChiSlice = createSlice({
    name: 'lop',
    initialState,
    reducers: {
        setListLopTinChi: (state, action) => {
            state.listData = action.payload;
            state.status = 'succeeded';
        },
        setListLopCombobox: (state, action) => {
            state.listLopHocCombobox = action.payload;
        },
        setStatus: (state, action) => {
            state.status = action.payload;
        },
        selectedIDDotHoc: (state, action) => {
            state.selectedDotHocId = action.payload;
            state.status = 'need_loading';
        },
        selectedIDLop: (state, action) => {
            state.selectedId = action.payload;
        },
        setCreateOrEditModel: (state, action: PayloadAction<CreateLopHocBSKTRequest>) => {
            state.createOrEditModel = action.payload;
            state.isShowCreateOrEditModal = true;
        },
        setShowCreateOrEditModal: (state, action) => {
            state.isShowCreateOrEditModal = action.payload;
        },
        setShowConfirmDeleteModal: (state, action) => {
            state.isShowConfirmDeleteModal = action.payload;
        },
        setThongKeVaMoLopData: (state, action) => {
            state.thongKeVaMoLopData = action.payload;
        },
        insertSuccess: (state, action) => {
            state.listData.push(action.payload);
            state.isShowCreateOrEditModal = false;
        },
        updateSuccess: (state, action) => {
            console.log('update lop: ' + JSON.stringify(action.payload));
            const index = state.listData.findIndex((item) => item.ID_lop_bskt === action.payload.ID_lop_bskt);
            if (index !== -1) {
                state.listData[index] = action.payload;
            }
            state.isShowCreateOrEditModal = false;
        },
        deleteSuccess: (state, action) => {
            const newData = state.listData.filter((item) => item.ID_lop_bskt !== action.payload.ID_lop_bskt);
            state.listData = newData;
            state.isShowConfirmDeleteModal = false;
            if (state.selectedId === action.payload) {
                state.selectedId = null;
            }
        },
        resetState: () => initialState,
        resetCreateOrEditModel: (state) => {
            state.createOrEditModel = {
                Chuyen_nganhs: '',
                ID_chuyen_nganhs: '',
                Den_ngay: new Date(),
                ID_cb: '',
                ID_dot_hoc: 0,
                ID_lop_bskt: 0,
                ID_mon: 0,
                ID_phong: 0,
                Ky_hieu_lop: '',
                STT_lop: '',
                Ten_lop_bskt: '',
                Tu_ngay: new Date()
            };
        }
    }
});

export const {
    setListLopTinChi,
    setListLopCombobox,
    setStatus,
    selectedIDLop,
    selectedIDDotHoc,
    setCreateOrEditModel,
    setShowCreateOrEditModal,
    setShowConfirmDeleteModal,
    setThongKeVaMoLopData,
    insertSuccess,
    updateSuccess,
    deleteSuccess,
    resetState,
    resetCreateOrEditModel
} = lopTinChiSlice.actions;

export const lopTinChiReducer = lopTinChiSlice.reducer;
